// Tablica tras. Wszystkie widoki ładowane leniwie (osobne chunki webpacka) —
// TinyMCE i duże formularze nie obciążają bundla startowego.
// meta.roles — role, które mają dostęp do trasy (egzekwowane w router.js);
// trasa bez meta.roles wymaga tylko zalogowania, meta.public — dostępna bez logowania.

export const ORDER_ROLES = ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_ORDERS']
// Dane osobowe klientów (zgody marketingowe) — bez roli tylko do odczytu zamówień.
export const ADMIN_ROLES = ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
export const CMS_ROLES = ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_CMS_ADMIN']
export const SUPER_ROLES = ['ROLE_SUPER_ADMIN']

const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: () => import('./views/pages/Dashboard'),
        meta: { roles: ORDER_ROLES }
    },
    {
        path: '/login',
        component: () => import('./views/pages/admin/Login'),
        meta: { public: true }
    },

    // Sklep
    {
        path: '/service-types',
        component: () => import('./views/pages/store/ServiceTypeList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/service-type/edit/:id',
        component: () => import('./views/pages/store/ServiceType'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/service-type/new',
        component: () => import('./views/pages/store/ServiceType'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/products',
        component: () => import('./views/pages/store/ProductItemList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/product/edit/:id',
        component: () => import('./views/pages/store/ProductItem'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/product/new',
        component: () => import('./views/pages/store/ProductItem'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/prices',
        component: () => import('./views/pages/store/ProductItemVariationList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/price/edit/:id',
        component: () => import('./views/pages/store/ProductItemVariation'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/price/new',
        component: () => import('./views/pages/store/ProductItemVariation'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },

    // Multimedia — dostępne dla każdego zalogowanego
    {
        path: '/images',
        component: () => import('./views/pages/ImageList')
    },
    {
        path: '/files',
        component: () => import('./views/pages/FileList')
    },

    // CMS
    {
        path: '/pages',
        component: () => import('./views/pages/cms/PageList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/page/edit/:id',
        component: () => import('./views/pages/cms/Page'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/page/new',
        component: () => import('./views/pages/cms/Page'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/faq-categories',
        component: () => import('./views/pages/cms/FaqCategoryList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/faq-category/edit/:id',
        component: () => import('./views/pages/cms/FaqCategory'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/faq-category/new',
        component: () => import('./views/pages/cms/FaqCategory'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/faqs',
        component: () => import('./views/pages/cms/FaqItemList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/faq/edit/:id',
        component: () => import('./views/pages/cms/FaqItem'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/faq/new',
        component: () => import('./views/pages/cms/FaqItem'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/departments',
        component: () => import('./views/pages/cms/DepartmentList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/department/edit/:id',
        component: () => import('./views/pages/cms/Department'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/department/new',
        component: () => import('./views/pages/cms/Department'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/fragments',
        component: () => import('./views/pages/cms/FragmentList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/fragment/edit/:id',
        component: () => import('./views/pages/cms/Fragment'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/infos',
        component: () => import('./views/pages/cms/InfoList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/info/edit/:id',
        component: () => import('./views/pages/cms/Info'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/info/new',
        component: () => import('./views/pages/cms/Info'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/about-items',
        component: () => import('./views/pages/cms/AboutItemList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/about-item/edit/:id',
        component: () => import('./views/pages/cms/AboutItem'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/about-item/new',
        component: () => import('./views/pages/cms/AboutItem'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/carousel-items',
        component: () => import('./views/pages/cms/CarouselItemList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/carousel-item/edit/:id',
        component: () => import('./views/pages/cms/CarouselItem'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/carousel-item/new',
        component: () => import('./views/pages/cms/CarouselItem'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/documents',
        component: () => import('./views/pages/cms/DocumentsList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/document/edit/:id',
        component: () => import('./views/pages/cms/Document'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/document/new',
        component: () => import('./views/pages/cms/Document'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/work-items',
        component: () => import('./views/pages/cms/WorkItemList'),
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/work-item/edit/:id',
        component: () => import('./views/pages/cms/WorkItemForm'),
        props: { mode: 'edit' },
        meta: { roles: CMS_ROLES }
    },
    {
        path: '/work-item/new',
        component: () => import('./views/pages/cms/WorkItemForm'),
        props: { mode: 'new' },
        meta: { roles: CMS_ROLES }
    },

    // Zamówienia
    {
        path: '/order-requests',
        component: () => import('./views/pages/store/OrderRequestList'),
        meta: { roles: ORDER_ROLES }
    },
    {
        path: '/paid-order-requests',
        component: () => import('./views/pages/store/OrderRequestPayedList'),
        meta: { roles: ORDER_ROLES }
    },
    {
        path: '/order-request/:id',
        component: () => import('./views/pages/store/OrderRequest'),
        meta: { roles: ORDER_ROLES }
    },
    {
        path: '/customer-consents',
        component: () => import('./views/pages/store/CustomerConsentList'),
        meta: { roles: ADMIN_ROLES }
    },

    // System — tylko SUPER_ADMIN
    {
        path: '/users',
        component: () => import('./views/pages/cms/UsersList'),
        meta: { roles: SUPER_ROLES }
    },
    {
        path: '/user/edit/:id',
        component: () => import('./views/pages/cms/User'),
        props: { mode: 'edit' },
        meta: { roles: SUPER_ROLES }
    },
    {
        path: '/user/new',
        component: () => import('./views/pages/cms/User'),
        props: { mode: 'new' },
        meta: { roles: SUPER_ROLES }
    },
]

export default routes;
